import React, { useState, useEffect } from "react";
import Icon from "components/AppIcon";
import { useDispatch, useSelector } from "react-redux";
import {
  createUserService,
  getUsersService,
  updateUserService,
} from "redux/services/users_service";
import { toast } from "react-toastify";

const AddAdminForm = ({
  onAddAdmin,
  selectedAdmin,
  onClearSelection,
  language,
}) => {
  const { permissions } = useSelector((state) => state.general);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role_id: "",
    permissions: [],
  });

  const [passwordStrength, setPasswordStrength] = useState(0);
  const [showPassword, setShowPassword] = useState(false);

  const [selectedPermissionIds, setSelectedPermissionIds] = useState([]);
  const handlePermissionChange = (permissionId) => {
    setSelectedPermissionIds((prev) => {
      if (prev.includes(permissionId)) {
        // Remove permission ID if it exists
        return prev.filter((id) => id !== permissionId);
      } else {
        // Add permission ID if it doesn't exist
        return [...prev, permissionId];
      }
    });

    setFormData((prev) => ({
      ...prev,
      permissions: selectedPermissionIds,
    }));
  };

  const translations = {
    en: {
      name: "Full Name",
      email: "Email Address",
      password: "Password",
      role: "Role",
      permissions: "Permissions",
      admin: "Admin",
      staff: "Staff",
      clientManagement: "Client Management",
      subscriptionRenewals: "Subscription Renewals",
      reportingAccess: "Reporting Access",
      addAdmin: "Add Admin",
      updateAdmin: "Update Admin",
      cancel: "Cancel",
      passwordStrength: "Password Strength",
      weak: "Weak",
      medium: "Medium",
      strong: "Strong",
      veryStrong: "Very Strong",
      entername: "Enter full name",
      enterEmail: "Enter email address",
      enterPassword: "Enter password",
      showPassword: "Show password",
      hidePassword: "Hide password",
    },
    ar: {
      name: "الاسم الكامل",
      email: "عنوان البريد الإلكتروني",
      password: "كلمة المرور",
      role: "الدور",
      permissions: "الصلاحيات",
      admin: "مشرف",
      staff: "موظف",
      clientManagement: "إدارة العملاء",
      subscriptionRenewals: "تجديد الاشتراكات",
      reportingAccess: "الوصول للتقارير",
      addAdmin: "إضافة مشرف",
      updateAdmin: "تحديث المشرف",
      cancel: "إلغاء",
      passwordStrength: "قوة كلمة المرور",
      weak: "ضعيفة",
      medium: "متوسطة",
      strong: "قوية",
      veryStrong: "قوية جداً",
      entername: "أدخل الاسم الكامل",
      enterEmail: "أدخل عنوان البريد الإلكتروني",
      enterPassword: "أدخل كلمة المرور",
      showPassword: "إظهار كلمة المرور",
      hidePassword: "إخفاء كلمة المرور",
    },
  };

  const t = translations[language];

  const dispatch = useDispatch();

  console.log(selectedAdmin);

  useEffect(() => {
    if (selectedAdmin?.permissions) {
      setSelectedPermissionIds(
        selectedAdmin.permissions.map((p) => p.id || p) // Handle both {id, name} and just id cases
      );
    }
  }, [selectedAdmin]);

  useEffect(() => {
    if (selectedAdmin) {
      setFormData({
        name: selectedAdmin.name,
        email: selectedAdmin.email,
        password: "",
        role_id: selectedAdmin?.role?.id,
        permissions: selectedAdmin.permissions || [],
      });
    }
  }, [selectedAdmin]);

  const calculatePasswordStrength = (password) => {
    let strength = 0;
    if (password.length >= 8) strength++;
    if (/[a-z]/.test(password)) strength++;
    if (/[A-Z]/.test(password)) strength++;
    if (/[0-9]/.test(password)) strength++;
    if (/[^A-Za-z0-9]/.test(password)) strength++;
    return strength;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "password") {
      setPasswordStrength(calculatePasswordStrength(value));
    }
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  /*  const handlePermissionChange = (permission) => {
    setFormData((prev) => ({
      ...prev,
      permissions: prev.permissions.includes(permission)
        ? prev.permissions.filter((p) => p !== permission)
        : [...prev.permissions, permission],
    }));
  };*/

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedAdmin) {
      console.log(formData);
     // onAddAdmin(formData);
      dispatch(createUserService(formData))
        .then((response) => {
          console.log(response);
          if (
            response?.payload?.status === 200 ||
            response?.payload?.status === 201
          ) {
            dispatch(getUsersService({ page: 1 }));
             toast.success(
                    language === "ar" ? "  تمت عملية الإضافة بنجاح " : "Added successfully !"
                  );
            //     navigate("/client-management");
          } else {
              Object.values(response.payload.errors).forEach((errorArray) => {
              errorArray.forEach((errorMessage) => {
                toast.warn(errorMessage);
              });
            });
          }
        })
        .catch((error) => {
          Object.values(response.payload.errors).forEach((errorArray) => {
              errorArray.forEach((errorMessage) => {
                toast.warn(errorMessage);
              });
            });
        })
        .finally(() => {
          //   setLoading(false); // Stop loading
        });
    } else {
      dispatch(updateUserService({ id: selectedAdmin?.id, formData: formData }))
        .then((response) => {
          console.log(response);
          if (
            response?.payload?.status === 200 ||
            response?.payload?.status === 201
          ) {
        toast.success(
                    language === "ar" ? "  تمت عملية التعديل بنجاح " : "Updated successfully !"
                  );
            dispatch(getUsersService({ page: 1 }));
          } else {
            Object.values(response.payload.errors).forEach((errorArray) => {
              errorArray.forEach((errorMessage) => {
                toast.warn(errorMessage);
              });
            });
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error("An error occurred");
        })
        .finally(() => {
          //   setLoading(false); // Stop loading
        });
    }
    /*setFormData({
      name: "",
      email: "",
      password: "",
      role: "Staff",
      permissions: [],
    });
    setPasswordStrength(0);
    if (selectedAdmin) {
      onClearSelection();
    }*/
  };

  const handleCancel = () => {
    setFormData({
      name: "",
      email: "",
      password: "",
      role_id: "",
      permissions: [],
    });
    setPasswordStrength(0);
    if (selectedAdmin) {
      onClearSelection();
    }
  };

  const getStrengthText = (strength) => {
    switch (strength) {
      case 0:
      case 1:
        return t.weak;
      case 2:
        return t.medium;
      case 3:
        return t.strong;
      case 4:
      case 5:
        return t.veryStrong;
      default:
        return t.weak;
    }
  };

  const getStrengthColor = (strength) => {
    switch (strength) {
      case 0:
      case 1:
        return "bg-red-500";
      case 2:
        return "bg-yellow-500";
      case 3:
        return "bg-blue-500";
      case 4:
      case 5:
        return "bg-green-500";
      default:
        return "bg-gray-300";
    }
  };

  return (
    <form onSubmit={handleSubmit} className="p-6 space-y-6">
      {/* Full Name */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {t.name}
        </label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          placeholder={t.entername}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
          required
        />
      </div>

      {/* Email */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {t.email}
        </label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          placeholder={t.enterEmail}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
          required
        />
      </div>

      {/* Password */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {t.password}
        </label>
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            value={formData.password}
            onChange={handleInputChange}
            placeholder={t.enterPassword}
            className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
            required={!selectedAdmin}
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
            title={showPassword ? t.hidePassword : t.showPassword}
          >
            <Icon name={showPassword ? "EyeOff" : "Eye"} size={20} />
          </button>
        </div>

        {/* Password Strength Indicator */}
        {formData.password && (
          <div className="mt-2">
            <div className="flex items-center space-x-2">
              <div className="flex-1 bg-gray-200 rounded-full h-2">
                <div
                  className={`h-2 rounded-full transition-all duration-300 ${getStrengthColor(
                    passwordStrength
                  )}`}
                  style={{ width: `${(passwordStrength / 5) * 100}%` }}
                ></div>
              </div>
              <span className="text-xs text-gray-600">
                {t.passwordStrength}: {getStrengthText(passwordStrength)}
              </span>
            </div>
          </div>
        )}
      </div>

      {/* Role */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {t.role}
        </label>
        <select
          name="role_id"
          value={formData.role_id}
          onChange={handleSelectChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
        >
          <option value="2">{t.staff}</option>
          <option value="1">{t.admin}</option>
        </select>
      </div>

      {/* Permissions */}
      {permissions?.map((permission) => (
        <label key={permission.id} className="flex items-center">
          <input
            type="checkbox"
            checked={selectedPermissionIds.includes(permission.id)}
            onChange={() => handlePermissionChange(permission.id)}
            className="w-4 h-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
          />
          <span className="ml-2 text-sm text-gray-700">
            {permission.translated_name}
          </span>
        </label>
      ))}

      {/* Action Buttons */}
      <div className="flex space-x-3 pt-4">
        <button
          type="submit"
          className="flex-1 bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 transition-colors font-medium"
        >
          {selectedAdmin ? t.updateAdmin : t.addAdmin}
        </button>

        {selectedAdmin && (
          <button
            type="button"
            onClick={handleCancel}
            className="flex-1 bg-gray-300 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-400 transition-colors font-medium"
          >
            {t.cancel}
          </button>
        )}
      </div>
    </form>
  );
};

export default AddAdminForm;
